export type CommercialService = "photovoltaic" | "ev_charger" | "maintenance" | null;
export type CommercialWizardStageId =
  | "service"
  | "need"
  | "details"
  | "location"
  | "roof"
  | "photos"
  | "summary";

export type CommercialWizardStage = {
  id: CommercialWizardStageId;
  label: string;
  persistedStep: number;
};

const COMMON_STAGES: CommercialWizardStage[] = [
  { id: "service", label: "Servicio", persistedStep: 0 },
  { id: "need", label: "Necesidad", persistedStep: 1 },
  { id: "details", label: "Datos", persistedStep: 2 },
  { id: "location", label: "Ubicación", persistedStep: 3 },
  { id: "photos", label: "Fotos", persistedStep: 5 },
  { id: "summary", label: "Resumen", persistedStep: 6 },
];

export function commercialWizardStages(
  service: CommercialService
): CommercialWizardStage[] {
  // PV legacy step 4 was the separate roof page. It now resumes in the
  // combined location/roof page while persisted step numbers stay unchanged.
  return service === "photovoltaic"
    ? COMMON_STAGES.map(stage => stage.id === "location" ? { ...stage, label: "Ubicación y cubierta" } : stage)
    : COMMON_STAGES;
}

export function persistedCommercialWizardStep(
  service: CommercialService,
  activeIndex: number
): number {
  const stages = commercialWizardStages(service);
  return stages[Math.max(0, Math.min(activeIndex, stages.length - 1))]!.persistedStep;
}

export function restoreCommercialWizardStep(
  service: CommercialService,
  persistedStep: unknown
): number {
  if (!service) return 0;
  const value = Number(persistedStep);
  if (!Number.isInteger(value) || value < 0 || value > 6) return 1;
  const stages = commercialWizardStages(service);
  // Legacy PV step 4 was the former roof screen; resume at its replacement,
  // the combined location/roof screen. EV and maintenance legacy 4/5 still
  // map to Photos. persistedStep 5 remains Photos for every service.
  if (service === "photovoltaic" && value === 4) return stages.findIndex(stage => stage.id === "location");
  const direct = stages.findIndex(stage => stage.persistedStep === value);
  if (direct >= 0) return direct;
  if (value === 4 || value === 5) return stages.findIndex(stage => stage.id === "photos");
  return stages.length - 1;
}
